module.exports = __webpack_public_path__ + "img/trash.5c8ccc06.svg";